import React from "react";

const Support = () => {
  return (
    <div className="content">
      <h1>Support</h1>
      <p>
        If you have any questions, feel free to reach out to us at{" "}
        <a href="mailto:support@loren-it.com">support@loren-it.com</a>.
      </p>
    </div>
  );
};

export default Support;
